const autoNgTemplateLoaderTemplate1 = require('./informationPanelOffline.html');

angular.module('portainer.app').component('informationPanelOffline', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'InformationPanelOfflineController',
});
